<tt-page *ngIf="!!get">
    <tt-page-heading class="col-xs-12 sp-0" ttModel="" ttTranslate></tt-page-heading>
    <tt-tabs [(ttSelectedId)]="get.tab" (ttSelectedIdChange)="readGrid()" ttRememberId="purchplanningoverview.tab" ttOnlyRemember>
        <tt-tab ttId="planning" ttLabel="planning"></tt-tab>
        <tt-tab ttId="received" ttLabel="received"></tt-tab>
    </tt-tabs>
    <tt-card class="col-xs-12 col-md-12 sp-0" style="max-width: 1250px">
        <form (submit)="readGrid()">
            <tt-input
                class="col-xs-12 col-md-6 sp-2"
                ttRememberId="purchplanningoverview.purch_order_no"
                ttLabel="purch_order_no"
                ttLabelView="top"
                [(ttModel)]="get.purch_order_no"
                [ttButtons]="purchOrderNoButtons"
            ></tt-input>
        </form>
        <tt-select
            class="col-xs-12 col-md-6 sp-2"
            ttRememberId="purchplanningoverview.stockplace_id"
            ttLabel="stockplace_id"
            ttLabelView="top"
            [(ttModel)]="get.stockplace_id"
            (ttModelChange)="readGrid()"
            [ttData]="stockplaces"
            ttDataName="stockplace_name"
            ttDataId="stockplace_id"
        ></tt-select>
        <tt-date-range
            class="col-xs-12 col-md-12 sp-2"
            ttRememberId="purchplanningoverview"
            ttLabel="date_fom_tom"
            ttLabelView="top"
            [(ttStartDate)]="get.date_fom"
            [(ttEndDate)]="get.date_tom"
            [(ttInterval)]="get.dateselector_index"
            (ttModelChange)="readGrid()"
        ></tt-date-range>
    </tt-card>
    <tt-grid [hidden]="get.tab !== 'planning'" *ngIf="!!planningGrid" class="flex-1" [(ttOptions)]="planningGrid"></tt-grid>
    <tt-grid [hidden]="get.tab !== 'received'" *ngIf="!!receivedGrid" class="flex-1" [(ttOptions)]="receivedGrid"></tt-grid>
    <tt-card *ngIf="get.show_setting === '1'" class="col-xs-12 sp-0">
        <tt-button-settings></tt-button-settings>
    </tt-card>
</tt-page>
